<template>
    <Button :enabled="enabled" :class="{'bg-yellow': enabled, 'bg-light-gray' : !enabled}" @click="$emit('click')">
        <span :class="{'black': enabled, 'mid-gray' : !enabled}" class="center">
            <slot></slot>
        </span>
    </Button>
</template>
<script>
import Button from '@/components/buttons/Button.vue';

export default {
    components: {
        Button
    },
    props: {
        enabled: {
            type: Boolean,
            default: true
        }
    }
};
</script>
